module.exports = __webpack_public_path__ + "static/media/ic_notification.e2748c8b.svg";